/* Restricciones de los campos de los formularios. */
export const EMAIL_MAX_LENGTH = 50;
export const DISTRICT_MAX_LENGTH = 50;
export const STREETNAME_MAX_LENGTH = 100;
export const STREETNUMBER_MIN = 1;
export const STREETNUMBER_MAX = 100000;
export const FLAT_MAX_LENGTH = 50;
export const DOOR_MAX_LENGTH = 30;
export const ZIPCODE_MIN_LENGTH = 4;
export const ZIPCODE_MAX_LENGTH = 8;
export const COMMENTS_MAX_LENGTH = 250;
export const PHONE_PREFIX_MIN_LENGTH = 2;
export const PHONE_PREFIX_MAX_LENGTH = 4;
export const PHONE_NUMBER_MIN_LENGTH = 6;
export const PHONE_NUMBER_MAX_LENGTH = 10;
export const SMILES_NUMBER_MIN_LENGTH = 9;
export const SMILES_NUMBER_MAX_LENGTH = 11;

/* Mensajes de error de validación de campo de formulario */
export const INPUT_OBLIGATORY_MESSAGE = 'Obligatorio';
export const INPUT_MAX_LENGTH_MESSAGE = 'Hasta';
export const INPUT_MIN_LENGTH_MESSAGE = 'Al menos';
export const INPUT_INVALID_FORMAT_MESSAGE = 'Formato inválido';
export const INPUT_NUMBER_MAX_MESSAGE = 'Máximo';
export const INPUT_NUMBER_MIN_MESSAGE = 'Mínimo';
